const anzSites = ['employer-seek-au', 'employer-seek-nz'];

const asiaSites = [
  'employer-seek-hk',
  'employer-seek-th',
  'employer-seek-sg',
  'employer-seek-id',
  'employer-seek-ph',
  'employer-seek-my',
];

export { anzSites, asiaSites };
